/*
 * IGIOO: keeps lens lines (`_role: lens`) in step with their frame.
 * Lines of one pair of glasses share the `_bundle` property. When the frame quantity changes or the
 * frame is removed, the lens lines are set to the same quantity (or removed).
 */
(() => {
  let syncing = false;
  const isLens = (item) => (item.properties && item.properties._role === 'lens') || item.product_type === 'Lens component';

  const sync = async () => {
    if (syncing) return;
    syncing = true;
    try {
      const cart = await (await fetch('/cart.js', { headers: { Accept: 'application/json' } })).json();
      const frames = {};
      cart.items.forEach((item) => {
        const bundle = item.properties && item.properties._bundle;
        if (bundle && !isLens(item)) frames[bundle] = (frames[bundle] || 0) + item.quantity;
      });
      const updates = {};
      cart.items.forEach((item) => {
        const bundle = item.properties && item.properties._bundle;
        if (!bundle || !isLens(item)) return;
        const quantity = frames[bundle] || 0;
        if (item.quantity !== quantity) updates[item.key] = quantity;
      });
      if (Object.keys(updates).length) {
        await fetch('/cart/update.js', { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ updates }) });
        document.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true, detail: { open: false } }));
      }
    } catch (error) {
      // Leave the cart as it is; the next cart update retries.
    } finally {
      syncing = false;
    }
  };

  const start = () => {
    if (window.theme && theme.pubsub) theme.pubsub.subscribe(theme.pubsub.PUB_SUB_EVENTS.cartUpdate, () => setTimeout(sync, 50));
    // Focal announces cart changes with a cart:updated event.
    document.documentElement.addEventListener('cart:updated', () => setTimeout(sync, 50));
    sync();
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start);
  else start();
})();
